import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Dashboard from "./components/Dashboard";
import SetupDetail from "./components/SetupDetail";
import Settings from "./components/Settings";
import Alerts from "./components/Alerts";
import AddSetupSheet from "./components/AddSetupSheet";
import StatusUpdateSheet from "./components/StatusUpdateSheet";
import api from "./lib/api";
import { applyTheme, getStoredTheme, toggleTheme } from "./lib/theme";

function App() {
  const [setups, setSetups] = useState([]);
  const [, setLoading] = useState(true);
  const [sheetOpen, setSheetOpen] = useState(false);
  const [editSetup, setEditSetup] = useState(null);
  const [statusOpen, setStatusOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [theme, setTheme] = useState(getStoredTheme());

  // Apply theme on mount and whenever changed
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const handleToggleTheme = () => {
    toggleTheme();
    setTheme(getStoredTheme());
  };

  const refresh = useCallback(async () => {
    try {
      const data = await api.listSetups();
      setSetups(data);
    } catch (e) {
      console.error("Failed to load setups", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    const id = setInterval(refresh, 60000);
    return () => clearInterval(id);
  }, [refresh]);

  const openAdd = () => { setEditSetup(null); setSheetOpen(true); };
  const openEdit = (s) => { setEditSetup(s); setSheetOpen(true); };

  return (
    <div className="App">
      <Toaster theme={theme} position="top-right" richColors />
      <BrowserRouter>
        <Layout
          onAddSetup={openAdd}
          onStatusUpdate={() => setStatusOpen(true)}
          sidebarOpen={sidebarOpen}
          onSidebarToggle={() => setSidebarOpen(!sidebarOpen)}
          theme={theme}
          onToggleTheme={handleToggleTheme}
        >
          <Routes>
            <Route path="/" element={
              <Dashboard
                setups={setups}
                onAddSetup={openAdd}
                onEditSetup={openEdit}
                onRefresh={refresh}
              />
            } />
            <Route path="/setups/:id" element={<SetupDetail />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/alerts" element={<Alerts />} />
          </Routes>
        </Layout>
        <AddSetupSheet
          open={sheetOpen}
          onOpenChange={(v) => { setSheetOpen(v); if (!v) setEditSetup(null); }}
          editSetup={editSetup}
          onCreated={() => refresh()}
          onUpdated={() => refresh()}
        />
        <StatusUpdateSheet
          open={statusOpen}
          onOpenChange={setStatusOpen}
          onDone={() => refresh()}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
